window.CoreHRUpdatesIntegartion = new function () {
    const self = this;
    const _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['CoreHrUpdatesIntegrationServer']);

    self.getCoreHrPayrollSettings = async (brandId) => {
        const url = `brands/${brandId}/settings`;
        const response = await _protected.request(url, 'GET');

        if (response.status === 200 && response?.data?.data?.settings) {
            return response.data.data.settings;
        }

        throw response;
    };
};